export enum CarJobCategory {
  
  AIR_CONDITIONING = "AIR_CONDITIONING",  //climatisation, chauffage, filtre d'habitacle
  BODY = "BODY",  // carrosserie, peinture, soudure, reservoirs
  BRAKES = "BRAKES",    //frein, disques, plaquettes, liquide de frein
  CONSUMABLES = "CONSUMABLES", // consommables, huiles, eau, carburant, 
  DIAGNOSTICS = "DIAGNOSTICS",    //diagnostic

  DISTRIBUTION = "DISTRIBUTION",  //courroie, distribution (transfer case)
  ELECTRIC = "ELECTRIC",  //circuits éléctriques, instruments, capteurs, batterie, demarreur, alternateur
  ENGINE = "ENGINE",  //moteur, turbochargeur, pompe à carburant, filtres à air/carburant, bougies d'allumage/prechauffage, injecteurs, liquide refroidissement
  EXHAUST = "EXHAUST",   //echappement, silencieux, Filtres à particules FAP, decalaminage
  INFOTAINMENT = "INFOTAINMENT", // information, divertissement

  INTERIOR = "INTERIOR",  // interieur, sieges, tapisserie, tableau de bord
  REVISION = "REVISION",  //revision, vidange, filtre à huile
  STEERING = "STEERING",  //volant, direction, rotules de direction, bielletes de direction, cardans, tenue de route, geometrie, parallisme
  SUSPENSION = "SUSPENSION",     //suspension, amortisseurs, triangles, essieux, Biellettes de Barre Stabilisatrice
  TRANSMISSION = "TRANSMISSION",  // boite de vitesse, embrayage, volant moteur
  
  VISION = "VISION",  // feux, phares, retroviseurs, essuie glace, optique, reglage
  WHEELS = "WHEELS"   // roues, roulements, pneus, equilibrage, tenue de route
}

export enum JobType {
    INSPECTION = "INSPECTION",
    ROUTINE = "ROUTINE",
    REPAIR = "REPAIR",
    TOWING = "TOWING",
    TECHNICAL_CONTROL = "TECHNICAL_CONTROL"
};

export enum JobStatus {
  DRAFT = "DRAFT",
  CANCELLED = "CANCELLED",
  SENT = "SENT",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  PENDING_MODIF = "PENDING_MODIF",
  COMPLETED = "COMPLETED"
};

export enum JobAction {
  CREATE = "CREATE",
  CANCEL = "CANCEL",
  CANCEL_MODIF = "CANCEL_MODIF",
  EDIT = "EDIT",
  EDIT_MODIF = "EDIT_MODIF",
  SEND = "SEND",
  REOPEN = "REOPEN",
  ACCEPT = "ACCEPT",
  ACCEPT_MODIF = "ACCEPT_MODIF",
  REJECT = "REJECT",
  REJECT_MODIF = "REJECT_MODIF",
  COMPLETE = "COMPLETE"
}

export enum KeepAction {
  CREATE = "CREATE",
  EDIT = "EDIT",
  PUBLISH = "PUBLISH",
  CLOSE = "CLOSE",
  SHARE = "SHARE",
  TOGGLE_FAV = "TOGGLE_FAV"
}

export interface JobActionItem {
  action: JobAction,
  title: string,
  icon?: string
};

export interface KeepActionItem {
  action: KeepAction,
  title: string,
  icon?: string
};


export enum JobItemStatus {
  SCHEDULED = "SCHEDULED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED"
};


export class KeepBasicData{

    public static carJobCategories: any = [
        {
          code: CarJobCategory.AIR_CONDITIONING,
          title: "Climatisation et chauffage"
        },
        {
          code: CarJobCategory.BODY,
          title: "Carrosserie"
        },
        {
          code: CarJobCategory.BRAKES,
          title: "Freinage"
        },
        {
          code: CarJobCategory.CONSUMABLES,
          title: "Consommables"
        },
        {
          code: CarJobCategory.DIAGNOSTICS,
          title: "Diagnostic"
        },
        {
          code: CarJobCategory.DISTRIBUTION,
          title: "Courroie et Distribution"
        },
        {
          code: CarJobCategory.ELECTRIC,
          title: "Démarrage et électricité"
        },
        {
          code: CarJobCategory.ENGINE,
          title: "Moteur et turbochargeur"
        },
        {
          code: CarJobCategory.EXHAUST,
          title: "Echappement"
        },
        {
          code: CarJobCategory.INFOTAINMENT,
          title: "Informations et Divertissement"
        },
        {
          code: CarJobCategory.INTERIOR,
          title: "Interieur et tapisserie"
        },
        {
          code: CarJobCategory.REVISION,
          title: "Révision et checkup de routine"
        },
        {
          code: CarJobCategory.STEERING,
          title: "Direction et géométrie"
        },
        {
          code: CarJobCategory.SUSPENSION,
          title: "Suspension"
        },
        {
          code: CarJobCategory.TRANSMISSION,
          title: "Transmision"
        },
        {
          code: CarJobCategory.VISION,
          title: "Vision - Feux, phares et éclairage"
        },
        {
          code: CarJobCategory.WHEELS,
          title: "Roues et pneus"
        },
    ];

    public static getCarJobCategoryTitle(code: string): string{

      //console.log(code)
      let ind = -1;
      ind = KeepBasicData.carJobCategories.findIndex((srv: any) => srv.code === code)

      return (ind >= 0) ? this.carJobCategories[ind].title : "";

    }


    public static jobTypes : any = [
      {
        code: JobType.INSPECTION,
        title: "Inspection"
      },
      {
        code: JobType.ROUTINE,
        title: "Routine"
      },
      {
        code: JobType.REPAIR,
        title: "Réparation"
      },
      {
        code: JobType.TOWING,
        title: "Remorquage"
      },
      {
        code: JobType.TECHNICAL_CONTROL,
        title: "Controle technique"
      }
  ];
  /*
  public static jobActions : JobActionItem[] = [
      {
        action: JobAction.ACCEPT,
        title: "Accepter"
      },
      {
        action: JobAction.CANCEL,
        title: "Annuler"
      },
      {
        action: JobAction.COMPLETE,
        title: "Compléter"
      },
      {
        action: JobAction.EDIT,
        title: "Editer"
      },
      {
        action: JobAction.REJECT,
        title: "Rejeter"
      },
      {
        action: JobAction.REOPEN,
        title: "Réouvrir"
      },
      {
        action: JobAction.SEND,
        title: "Envoyer"
      }
  ];
  */

  
  public static jobActionItems : JobActionItem[] = [
      {
        action: JobAction.ACCEPT,
        title: "Accepter",
        icon: 'accept'
      },
      {
        action: JobAction.ACCEPT_MODIF,
        title: "Accepter modif",
        icon: 'accept'
      },
      {
        action: JobAction.CANCEL,
        title: "Annuler",
        icon: 'cancel'
      },
      {
        action: JobAction.CANCEL_MODIF,
        title: "Annuler modif",
        icon: 'cancel'
      },
      {
        action: JobAction.COMPLETE,
        title: "Compléter",
        icon: 'complete'
      },
      {
        action: JobAction.EDIT,
        title: "Editer",
        icon: 'edit'
      },
      {
        action: JobAction.EDIT_MODIF,
        title: "Editer modif",
        icon: 'edit'
      },
      {
        action: JobAction.REJECT,
        title: "Rejeter",
        icon: 'reject'
      },
      {
        action: JobAction.REJECT_MODIF,
        title: "Rejeter modif",
        icon: 'reject'
      },
      {
        action: JobAction.REOPEN,
        title: "Réouvrir",
        icon: 'open'
      },
      {
        action: JobAction.SEND,
        title: "Envoyer",
        icon: 'send'
      }
  ];

}